import React, { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import HeroSearch from '../../components/HeroSearch/HeroSearch';
import Offers from '../../components/Offers/Offers';
import PropertyTypeCarousel from '../../components/PropertyTypeCarousel/PropertyTypeCarousel';
import PopularDestinations from '../../components/PopularDestinations/PopularDestinations';
import WeekendDeals from '../../components/WeekendDeals/WeekendDeals';
import UniqueProperties from '../../components/UniqueProperties/UniqueProperties';
import HomesGuestsLove from '../../components/HomesGuestsLove/HomesGuestsLove';
import Footer from '../../components/Footer/Footer';
import './Home.css';

const WELCOME_POPUP_STORAGE_KEY = 'tourasco_welcome_popup_seen_v1';

/** Set true to show “Browse by property type” on the home page again. */
const SHOW_PROPERTY_TYPE_CAROUSEL = false;

const markWelcomePopupSeen = () => {
  try {
    localStorage.setItem(WELCOME_POPUP_STORAGE_KEY, '1');
  } catch {
    /* private mode / blocked storage */
  }
};

const Home = ({ onSearch, onNavigate, searchParams, onViewHotel }) => {
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let seen = false;
    try {
      seen = localStorage.getItem(WELCOME_POPUP_STORAGE_KEY) === '1';
    } catch {
      seen = false;
    }
    if (!seen) {
      setShowWelcomePopup(true);
      markWelcomePopupSeen();
    }
  }, []);

  return (
    <>
      <Header onLogoClick={() => window.scrollTo(0, 0)} onNavigate={onNavigate} />
      {showWelcomePopup && (
        <div className="home-welcome-modal" role="dialog" aria-modal="true" aria-label="Welcome offer">
          <div className="home-welcome-modal__card">
            <button
              type="button"
              className="home-welcome-modal__close"
              aria-label="Close welcome popup"
              onClick={() => {
                markWelcomePopupSeen();
                setShowWelcomePopup(false);
              }}
            >
              ×
            </button>
            <p className="home-welcome-modal__tag">Welcome to Tourasco Hotels</p>
            <h2 className="home-welcome-modal__title">Book best hotels at good prices</h2>
            <p className="home-welcome-modal__text">
              Discover top stays, compare great deals, and reserve your perfect hotel in minutes.
            </p>
            <button
              type="button"
              className="home-welcome-modal__cta"
              onClick={() => {
                markWelcomePopupSeen();
                setShowWelcomePopup(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Start Searching
            </button>
          </div>
        </div>
      )}
      <main>
        <HeroSearch onSearch={onSearch} />
        <Offers />
        {SHOW_PROPERTY_TYPE_CAROUSEL ? (
          <PropertyTypeCarousel onViewHotel={onViewHotel} />
        ) : null}
        <PopularDestinations onSearch={onSearch} />
        <WeekendDeals onViewHotel={onViewHotel} />
        <UniqueProperties onViewHotel={onViewHotel} />
        <HomesGuestsLove onViewHotel={onViewHotel} />
      </main>
      <Footer />
    </>
  );
};

export default Home;
